import { Box, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

import React, { useCallback } from "react";
import { ChatSearchResult } from "../../api/types";
import { ContentKindThatShouldNotStartWithSenderName } from "../../enums";
import typography from "../../typography";
import UserAvatar from "../UserAvatar";
import { formatMessageText, friendlyDate, getMessageIcon } from "./renderer";

interface Props {
  result: ChatSearchResult;
  onSearchResultSelected: (result: ChatSearchResult) => void;
}


function ChatSearchResultItem({result, onSearchResultSelected}: Props) {
  const message = result.message;
  const chat = result.chat;
  const user = message.author;
  const senderName = message.author.me ? 'You' : `${user.first_name} ${user.last_name}`;

  const avatar = (
    <UserAvatar
      firstName={user.first_name}
      lastName={user.last_name}
      entityUserXrefUuid={user.entity_user_xref_uuid}
    />
  );

  const messageText = formatMessageText(message);
  const MessageIcon = getMessageIcon(message);
  const timeOrDate = friendlyDate(new Date(message.created_at));

  const shouldShowSenderName = !ContentKindThatShouldNotStartWithSenderName.has(message.content.kind);

  const itemClicked = useCallback(() => {
    onSearchResultSelected(result);
  }, [result, onSearchResultSelected]);

  return (
    <ListItem disableGutters>

      <ListItemButton onClick={itemClicked}>
        <ListItemAvatar>
          {avatar}
        </ListItemAvatar>
        <ListItemText>
          <Box display={'flex'} flexDirection={'column'} width={'100%'}>
            <Box display={'flex'}>
              <Box component='div'
                   sx={{textOverflow: 'ellipsis', overflow: 'hidden', fontWeight: 'bold', flexGrow: 1}}>
                <Typography noWrap fontWeight={'bold'}>
                  {chat.title}
                </Typography>
              </Box>
              <Box sx={{flexShrink: 1}}>
                <Typography
                  component="span"
                  fontSize={typography.xs}
                  color={grey[500]}
                  marginX={1}
                  sx={{textWrap: "nowrap"}}
                >
                  {timeOrDate}
                </Typography>
              </Box>
            </Box>
            <Box component='div'
                 sx={{
                   textOverflow: 'ellipsis', overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical',
                   WebkitLineClamp: 2,
                 }}>
              <Typography sx={{textOverflow: 'ellipsis'}}>
                {shouldShowSenderName ? (
                  <Typography component="span" fontWeight={400} fontSize={typography.sm}>{senderName}: </Typography>
                ) : null}
                {MessageIcon ? <MessageIcon sx={{
                  fontSize: '1.2rem',
                  color: grey[600],
                  verticalAlign: 'text-top',
                  marginRight: '0.2rem'
                }}/> : null}
                <Typography component="span" fontWeight={200} fontSize={typography.sm}>

                  {messageText}
                </Typography>
              </Typography>
            </Box>
          </Box>
        </ListItemText>
      </ListItemButton>
    </ListItem>
  );
}


export default ChatSearchResultItem;
